import {
  CONDITION_DISCOUNT,
  CONDITION_NEW,
  CONDITION_REFURBISHED,
  CONDITION_UNDETERMINED,
  CONDITION_USED
} from '@/constants/offers'
import type { ProductCategory, ProductLabel } from '~/types/product'
import type { Condition } from '~/types/offer'

interface PayloadGetCondition {
  condition: Condition
  category: ProductCategory
}

interface PayloadGetConditionName {
  condition: Condition
  value?: number
  ignored?: string[]
  category?: ProductCategory
}

export const getConditionLabel = (
  { condition, category }: PayloadGetCondition
): ProductLabel | undefined => {
  const { $i18n } = useNuxtApp()

  if (!category.is_shown_condition) {
    return
  }

  switch (condition.key) {
    case CONDITION_NEW:
      break
    case CONDITION_UNDETERMINED:
      break
    case CONDITION_USED:
      return {
        background_color: '#DBE7FF',
        font_color: '#3764BE',
        text:
          condition.value <= 2
            ? `${$i18n.t('offers.condition_used')} ${$i18n.t(
                `offers.conditions.${condition.value}`
              )}`
            : ($i18n.t('offers.condition_used') as string)
      }
    case CONDITION_REFURBISHED:
      return {
        background_color: '#DBE7FF',
        font_color: '#3764BE',
        text: <string>$i18n.t('offers.condition_refurbished')
      }
    case CONDITION_DISCOUNT:
      return {
        background_color: '#DBE7FF',
        font_color: '#3764BE',
        text: <string>$i18n.t('offers.condition_discount')
      }
  }
}

export const getConditionTitle = (condition: Condition) => {
  const { $i18n } = useNuxtApp()

  switch (condition.key) {
    case CONDITION_USED:
      return $i18n.t('offers.condition_used') as string
    case CONDITION_REFURBISHED:
      return $i18n.t('offers.condition_refurbished') as string
    case CONDITION_NEW:
      return $i18n.t('offers.condition_new') as string
    case CONDITION_DISCOUNT:
      return $i18n.t('offers.condition_discount') as string
    case CONDITION_UNDETERMINED:
      return '' as string
  }
}

export const getConditionNameShort = (
  { condition, value, ignored, category }: PayloadGetConditionName
): string => {
  const { $i18n } = useNuxtApp()
  const isIgnored = ignored && ignored.includes(condition.key)
  const isShowCategory = category?.is_shown_condition

  if (isIgnored && !isShowCategory) {
    return ''
  }

  let name = <string>getConditionTitle(condition)

  if (value && condition.key === CONDITION_USED && condition.value <= value) {
    name = `${name} ${$i18n.t(`offers.conditions.${condition.value}`)}`
  }
  return name || ''
}
